/* "Open now" badge.

   Computed in the browser, not on the server: Shopify caches pages on the CDN,
   so a server-rendered open/closed state would be served to everyone from
   whenever the page was first built. Amsterdam time is derived with Intl so it
   stays correct across DST without a timezone library. */
(function () {
  'use strict';
  var el = document.querySelector('[data-aw-opennow]');
  if (!el) return;
  var out = el.querySelector('[data-aw-opennow-text]');

  function nowInAmsterdam() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit',
      minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { day: o.weekday, minutes: parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10) };
  }

  var t = nowInAmsterdam();
  var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(t.day) !== -1;
  var open = weekday && t.minutes >= 540 && t.minutes < 1020; /* 09:00–17:00 */

  el.classList.add(open ? 'opennow--open' : 'opennow--closed');
  out.textContent = open ? 'Nu open' : 'Nu gesloten';
  el.hidden = false;
})();
